module.exports = __webpack_public_path__ + "static/media/arxontisa-writer.3018994c.jpg";